import { useLocation } from 'react-router-dom';
import { orderSummaryPage } from 'features/order-tracker/router/path-constants';
import { useSelector } from 'react-redux';
import {
  getChatQidForEntryPage,
  getChatQidForSummaryPage,
  getOrderSummary,
} from '../selectors';

interface AnalyticsTags {
  [key: string]: string;
}

export const useAnalyticsTags = (): AnalyticsTags => {
  const { pathname } = useLocation();
  const analyticsTags: AnalyticsTags = {};
  const summaryPathRegex = new RegExp(`${orderSummaryPage}/?`);
  const { isGeneralAPIFailed } = useSelector(getOrderSummary);
  const summaryPageChatQid = useSelector(getChatQidForSummaryPage);
  const entryPageChatQid = useSelector(getChatQidForEntryPage);
  if (summaryPathRegex.test(pathname)) {
    analyticsTags['data-current-page-path'] = '/content/bt/business/en/order-tracker/order-tracker-summary';
    analyticsTags['data-page-name'] = isGeneralAPIFailed
      ? 'BTB:BYA:Track your order:Summary error'
      : 'BTB:BYA:Track your order:Order summary';
    analyticsTags['data-actual-current-page-name'] = 'order-tracker-summary';
    analyticsTags['data-hier1'] = isGeneralAPIFailed
      ? 'BTB,BYA,Track your order,Summary error'
      : 'BTB,BYA,Track your order,Order summary';
    analyticsTags['data-current-homepage-path'] = '/content/bt/business/en';
    analyticsTags['data-chat-qid'] = summaryPageChatQid;
  } else {
    analyticsTags['data-current-page-path'] = '/content/bt/business/en/order-tracker';
    analyticsTags['data-page-name'] = 'BTB:BYA:Track your order:Enter your details ';
    analyticsTags['data-actual-current-page-name'] = 'order-tracker';
    analyticsTags['data-hier1'] = 'BTB,BYA,Track your order,Enter your details ';
    analyticsTags['data-current-homepage-path'] = '/content/bt/business/en';
    analyticsTags['data-chat-qid'] = entryPageChatQid;
  }
  
  return analyticsTags;
};
